<template>
  <div>
    <HeaderPartial />
    <router-view v-if="true" v-bind="childProps" />
    <FooterPartial />
    <CookiesBannerPartial />
    <CookiesManagerPartial />
  </div>
</template>

<script>
// ***********IMPORTANTE***********
// No quitar bajo ningún concepto el v-if true, se rompe el SEO.
// ***********IMPORTANTE***********

// TODO: Centralizar parche de SEO (v-if="true")

// TODO: Condicionar aplicación de la directiva (v-if="true")
// según si la ruta es indexable o no.

// TODO: Crear una directiva propia para el parche?

// TODO: Mover secciones a resources/js/lego/pages/*

import { notifyRoute } from '@/lego/utils/route/notifier';
import Skeleton from '@/lego/layouts/Skeleton.vue';
import HeaderPartial from '@/lego/partials/Header.vue';
import FooterPartial from '@/lego/partials/Footer.vue';
import CookiesBannerPartial from '@/lego/partials/cookies/Banner.vue';
import CookiesManagerPartial from '@/lego/partials/cookies/Manager.vue';
// import { Link } from '@inertiajs/inertia-vue';

export default {
  layout: Skeleton,
  components: {
    HeaderPartial,
    FooterPartial,
    CookiesBannerPartial,
    CookiesManagerPartial,
    // Link,
  },
  props: {
    childProps: {
      type: [Object, Array],
    },
  },

  setup() {
    notifyRoute();
  },
};
</script>

<style lang="postcss" scoped>
input {
  &:autofill,
  &:autofill:hover,
  &:autofill:focus,
  &:autofill:active {
    @apply bg-clip-text;
  }
}
</style>
